<ion-grid class="ion-no-padding">
    <ion-row>
        <ion-col class="card ion-justify-content-center ion-align-items-center" size="12" sizeSm="6" sizeXl="12">
            <debit-card [data]="Data"></debit-card>
        </ion-col>
        <ion-col class="details ion-padding-top ion-justify-content-center ion-align-items-center" size="12" sizeSm="6"
            sizeXl="12">

            <ion-row class="balance ion-justify-content-center ion-align-items-center">

                <ion-col class="header ion-text-center ion-justify-content-center ion-align-items-center"
                    size="12">Saldo</ion-col>

                <ion-col *ngFor="let item of Balance"
                    class="ion-text-center ion-justify-content-center ion-align-items-center">
                    {{(item?.Balance||'0') +' '+ (item?.Currency?.Symbol||'') }}
                </ion-col>

            </ion-row>

            <ion-row class="historic ion-margin-top" *ngIf="Historic?.length>0">

                <ion-col size="12" class="ion-hide-xl-down ion-no-padding ion-text-center">

                    <ion-list-header>Últimos movimentos</ion-list-header>

                    <ion-grid class="table ion-no-padding ion-no-margin">

                        <ion-row class="table-body with-button-opacity" *ngFor="let item of Historic"
                            [class.disabled]="item?.Status?.Id=='8'">
                            <ion-col style="max-width: 50px;">
                                <icon-status [color]="item?.Type?.Id == '2' ? 'warning': 'success'"
                                    [icon]="item?.Type?.Id == '2' ? 'trending-down-outline':item?.Type?.Id == '1' ? 'trending-up-outline': ''"></icon-status>
                            </ion-col>

                            <ion-col>
                                {{item?.Type?.Name||'--'}}
                            </ion-col>
                            <ion-col>
                                <date-tooltip [tooltip]="false" [date]="item?.CreateDate"></date-tooltip>
                            </ion-col>
                            <ion-col style="max-width: 80px;" class="ion-text-end ion-align-content-center">
                                <span class="amount"> {{item?.AmountLabel}}</span>
                            </ion-col>
                            <ion-col class="buttons-size flex-justify-end">
                                <ion-button *ngIf="item?.Type?.Id == '2'" fill="clear" size="small"
                                    (click)="OnView($event, item)" [actionsPermissions]="EnumActionsPermissions.VIEW">
                                    <ion-icon name="eye-outline" slot="icon-only"></ion-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>

                    </ion-grid>

                    <!-- </ion-col>
                <ion-col size="12" class="ion-text-center"> -->
                    <ion-button fill="clear" *ngIf="Historic?.length < TotalRegists" (click)="OnLoadMore()">ver
                        mais</ion-button>
                </ion-col>

            </ion-row>
        </ion-col>
    </ion-row>
</ion-grid>